(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-instant-quote]');
  roots.forEach(initQuote);
  document.addEventListener('shopify:section:load', function(event) { event.target.querySelectorAll('[data-instant-quote]').forEach(initQuote); });

  function initQuote(root) {
    if (root.hiveQuote) return;
    var els = {
      dropzone: root.querySelector('[data-iq-dropzone]'),
      input: root.querySelector('[data-iq-file]'),
      browse: root.querySelector('[data-iq-browse]'),
      replace: root.querySelector('[data-iq-replace]'),
      empty: root.querySelector('[data-iq-empty]'),
      canvas: root.querySelector('[data-iq-canvas]'),
      help: root.querySelector('[data-iq-viewer-help]'),
      filebar: root.querySelector('[data-iq-filebar]'),
      filename: root.querySelector('[data-iq-filename]'),
      filemeta: root.querySelector('[data-iq-filemeta]'),
      status: root.querySelector('[data-iq-status]'),
      materials: root.querySelector('[data-iq-materials]'),
      layer: root.querySelector('[data-iq-layer]'),
      infill: root.querySelector('[data-iq-infill]'),
      supports: root.querySelector('[data-iq-supports]'),
      rush: root.querySelector('[data-iq-rush]'),
      quantity: root.querySelector('[data-iq-quantity]'),
      minus: root.querySelector('[data-iq-qty-minus]'),
      plus: root.querySelector('[data-iq-qty-plus]'),
      priceButton: root.querySelector('[data-iq-price-button]'),
      addCart: root.querySelector('[data-iq-add-cart]'),
      cartNote: root.querySelector('[data-iq-cart-note]'),
      quoteEmpty: root.querySelector('[data-iq-quote-empty]'),
      result: root.querySelector('[data-iq-result]'),
      priceLabel: root.querySelector('[data-iq-price-label]'),
      price: root.querySelector('[data-iq-price]'),
      breakdown: root.querySelector('[data-iq-breakdown]'),
      printingPrice: root.querySelector('[data-iq-printing-price]'),
      repairPrice: root.querySelector('[data-iq-repair-price]'),
      badge: root.querySelector('[data-iq-badge]'),
      weight: root.querySelector('[data-iq-weight]'),
      time: root.querySelector('[data-iq-time]'),
      size: root.querySelector('[data-iq-size]'),
      turnaround: root.querySelector('[data-iq-turnaround]'),
      accuracy: root.querySelector('[data-iq-accuracy]'),
      contactSummary: root.querySelector('[data-iq-contact-summary]')
    };

    var state = {
      file: null,
      analysis: null,
      quote: null,
      mesh: null,
      rotationX: -0.52,
      rotationY: 0.68,
      zoom: 1,
      dragging: false,
      pointerX: 0,
      pointerY: 0,
      renderer: null, solidViewer: null, scene: null, source: null, previewDimensions: null, moldEnabled: false, moldResult: null, loadingId: 0, fileLoading: false, orderBusy: false
    };

    var config = {
      currency: root.dataset.currency || 'AUD',
      baseCurrency: root.dataset.shopCurrency || root.dataset.currency || 'AUD',
      locale: root.dataset.locale || 'en-AU',
      variantId: number(root.dataset.variantId, 0),
      unitPrice: number(root.dataset.unitPrice, 0),
      productHandle: root.dataset.productHandle || '',
      apiUrl: (root.dataset.apiUrl || '').trim(),
      maxBytes: number(root.dataset.maxFileMb, 50) * 1024 * 1024,
      buildVolume: number(root.dataset.buildVolume, 270),
      setupFee: number(root.dataset.setupFee, 800),
      machineRate: number(root.dataset.machineRate, 400),
      minimumPrice: number(root.dataset.minimumPrice, 1500),
      repairFeeCents: 500,
      gstIncluded: root.dataset.gstIncluded === 'true',
      estimateNotice: els.accuracy.textContent
    };


    function canPrice() {
      if (config.currency !== config.baseCurrency) return false;
      if (state.moldEnabled && (!state.moldResult || state.moldMaterialIssue || !window.HiveMoldMaterial)) return false;
      return !!(state.analysis && (state.analysis.canEstimate || (!state.moldEnabled && config.apiUrl)) &&
        (!state.analysis.dimensions || state.analysis.dimensions.every(function(d){return d > 0 && d <= config.buildVolume + .001;})));
    }
    function refreshEligibility() {
      els.priceButton.disabled = !canPrice();
      if (config.currency !== config.baseCurrency) { els.priceButton.textContent = 'Use '+config.baseCurrency+' for Custom Jobs'; showStatus('Custom Jobs pricing is in '+config.baseCurrency+'. Switch the store currency to '+config.baseCurrency+' before ordering.', true); return; }
      if (state.moldEnabled && state.moldMaterialIssue) els.priceButton.textContent = 'Request a reviewed quote';
      else if (state.moldEnabled && !state.moldResult) els.priceButton.textContent = 'Create your mold first';
      else els.priceButton.textContent = state.moldEnabled ? 'Calculate mold estimate' : 'Calculate my estimate';
      if (state.quote) renderQuote();
    }
    function restoreSource() {
      state.scene=null;
      if (state.source) { state.mesh = state.source.mesh; state.analysis = Object.assign({},state.source.analysis); }
      state.previewDimensions = null;
      drawModel();
    }
    root.hiveQuote = {
      state:state, config:config, els:els, loadFile:loadFile, canPrice:canPrice,
      resetQuote:resetQuote, renderQuote:renderQuote, refreshEligibility:refreshEligibility,
      restoreSource:restoreSource, drawModel:drawModel, showStatus:showStatus,
      calculateQuote:calculateQuote, selectedMaterial:selectedMaterial, specification:currentSpecification,
      repairFeeCents:repairFeeCents, money:money, orderPriceProblem:orderPriceProblem,
      setPreview:function(mesh, dimensions){state.scene=null;state.mesh=mesh;state.previewDimensions=dimensions;state.zoom=1;drawModel();},
      setScene:function(scene, resetView){state.scene=scene;state.previewDimensions=scene.bounds.dimensions;if(resetView)state.zoom=1;drawModel();},
      clearScene:function(){state.scene=null;if(state.solidViewer)state.solidViewer.clear();},
      applyMold:function(result){
        state.moldResult=result;
        state.analysis={canEstimate:true,format:'Generated mold STL',volumeCm3:result.volumeCm3,
          dimensions:[0,1,2].map(function(i){return Math.max.apply(null,result.parts.map(function(p){return p.dimensions[i];}));}),
          triangleCount:result.parts.reduce(function(n,p){return n+p.triangles.length;},0)};
        resetQuote();refreshEligibility();
      }
    };

    root.querySelector('[data-mold-repair-price-notice]').textContent = money(config.repairFeeCents);

    selectInitialMaterial();
    bindUpload();
    bindControls();
    bindViewer();
    resizeCanvas();

    if (window.ResizeObserver) {
      new ResizeObserver(function () { resizeCanvas(); drawModel(); }).observe(els.dropzone);
    } else {
      window.addEventListener('resize', function () { resizeCanvas(); drawModel(); });
    }

    function selectInitialMaterial() {
      var inputs = Array.prototype.slice.call(els.materials.querySelectorAll('input[type="radio"]'));
      if (!inputs.length) return;
      var chosen = inputs.find(function (input) { return input.dataset.default === 'true'; }) || inputs[0];
      chosen.checked = true;
    }

    function bindUpload() {
      function openPicker(event) {
        if (event) event.stopPropagation();
        els.input.value = '';
        els.input.click();
      }
      els.browse.addEventListener('click', openPicker);
      els.replace.addEventListener('click', openPicker);
      els.input.addEventListener('change', function () { if (els.input.files[0]) loadFile(els.input.files[0]); });
      els.dropzone.addEventListener('click', function (event) {
        if (!state.file && !event.target.closest('button')) els.input.click();
      });
      els.dropzone.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && !state.file) {
          event.preventDefault();
          els.input.click();
        }
      });
      ['dragenter', 'dragover'].forEach(function (name) {
        els.dropzone.addEventListener(name, function (event) {
          event.preventDefault();
          if (event.dataTransfer) event.dataTransfer.dropEffect = 'copy';
          els.dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (name) {
        els.dropzone.addEventListener(name, function (event) {
          event.preventDefault();
          els.dropzone.classList.remove('is-dragover');
        });
      });
      els.dropzone.addEventListener('drop', function (event) {
        var file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
        if (file) loadFile(file);
      });
    }

    function bindControls() {
      els.minus.addEventListener('click', function () { setQuantity(number(els.quantity.value, 1) - 1); });
      els.plus.addEventListener('click', function () { setQuantity(number(els.quantity.value, 1) + 1); });
      els.quantity.addEventListener('change', function () { setQuantity(els.quantity.value); });
      [els.layer, els.infill, els.supports, els.rush, els.materials].forEach(function (control) {
        control.addEventListener('change', function () {
          drawModel();
          quoteInputsChanged();
        });
      });
      els.priceButton.addEventListener('click', function () { calculateQuote(true); });
      els.addCart.addEventListener('click', addToCart);
    }

    function bindViewer() {
      els.dropzone.addEventListener('pointerdown', function (event) {
        if (!state.mesh || event.target.closest('button')) return;
        state.dragging = true;
        state.pointerX = event.clientX;
        state.pointerY = event.clientY;
        els.dropzone.setPointerCapture(event.pointerId);
      });
      els.dropzone.addEventListener('pointermove', function (event) {
        if (!state.dragging) return;
        state.rotationY -= (event.clientX - state.pointerX) * .012;
        state.rotationX -= (event.clientY - state.pointerY) * .012;
        state.pointerX = event.clientX;
        state.pointerY = event.clientY;
        drawModel();
      });
      els.dropzone.addEventListener('pointerup', function () { state.dragging = false; });
      els.dropzone.addEventListener('pointercancel', function () { state.dragging = false; });
      els.dropzone.addEventListener('wheel', function (event) {
        if (!state.mesh) return;
        event.preventDefault();
        var zoomFactor = Math.exp(clamp(-event.deltaY * .0018, -.4, .4));
        state.zoom = clamp(state.zoom * zoomFactor, minimumViewerZoom(), 2.8);
        drawModel();
      }, { passive: false });
    }

    function minimumViewerZoom() {
      if (!state.analysis || !state.analysis.dimensions || !els.canvas.width || !els.canvas.height) return .04;
      var dims = state.previewDimensions || state.analysis.dimensions;
      var maxDim = Math.max(dims[0], dims[1], dims[2], 1);
      var halfPlate = config.buildVolume / (2 * maxDim);
      var baseZ = -dims[2] / (2 * maxDim) - .003;
      var cosY = Math.cos(state.rotationY), sinY = Math.sin(state.rotationY);
      var cosX = Math.cos(state.rotationX), sinX = Math.sin(state.rotationX);
      var maxX = 0;
      var maxY = 0;
      [-halfPlate, halfPlate].forEach(function (x) {
        [-halfPlate, halfPlate].forEach(function (y) {
          var x1 = x * cosY - y * sinY;
          var y1 = x * sinY + y * cosY;
          var y2 = y1 * cosX - baseZ * sinX;
          maxX = Math.max(maxX, Math.abs(x1));
          maxY = Math.max(maxY, Math.abs(y2));
        });
      });
      var shortestSide = Math.min(els.canvas.width, els.canvas.height);
      var baseScaleX = 1.38 * shortestSide / els.canvas.width;
      var baseScaleY = 1.38 * shortestSide / els.canvas.height;
      var horizontalFit = maxX ? .9 / (maxX * baseScaleX) : .55;
      var verticalFit = maxY ? .86 / (maxY * baseScaleY) : .55;
      return clamp(Math.min(horizontalFit, verticalFit) * .96, .01, .55);
    }

    function setQuantity(value) {
      els.quantity.value = clamp(Math.round(number(value, 1)), 1, 100);
      quoteInputsChanged();
    }

    function quoteInputsChanged() {
      if (!state.quote) return;
      if (config.apiUrl && !state.moldEnabled) {
        resetQuote();
        els.priceButton.disabled = false;
        els.priceButton.textContent = 'Slice and price it';
        showStatus('Settings changed. Re-slice the model to refresh the production price.');
      } else if (state.analysis && state.analysis.canEstimate) {
        calculateQuote(false);
      }
    }

    async function loadFile(file) {
      if (state.orderBusy) return;
      clearStatus();
      if (file.size > config.maxBytes) {
        showStatus('That file is larger than ' + formatBytes(config.maxBytes) + '. Please reduce it or request a reviewed quote.', true);
        return;
      }
      var extension = (file.name.split('.').pop() || '').toLowerCase();
      if (['stl', 'obj', '3mf', 'step', 'stp'].indexOf(extension) === -1) {
        showStatus('Please choose an STL, OBJ, 3MF, STEP or STP file.', true);
        return;
      }

      var loadId = ++state.loadingId;
      state.scene=null; if(state.solidViewer)state.solidViewer.clear();
      state.source = null; state.moldResult = null; state.previewDimensions = null;
      resetQuote();
      state.file = file;
      state.analysis = null;
      state.mesh = null;
      state.fileLoading = true;
      root.dispatchEvent(new CustomEvent("hive:file-loading"));
      els.empty.hidden = true;
      els.filebar.hidden = false;
      els.help.hidden = true;
      els.filename.textContent = file.name;
      els.filemeta.textContent = formatBytes(file.size) + ' · Reading geometry…';
      els.priceButton.disabled = true;
      els.priceButton.textContent = 'Reading your model…';

      try {
        if (extension === 'stl') {
          var buffer = await file.arrayBuffer();
          if (loadId !== state.loadingId) return;
          var parsed = isBinarySTL(buffer) ? parseBinarySTL(buffer) : parseASCIISTL(new TextDecoder().decode(buffer));
          acceptAnalysis(parsed, 'STL');
        } else if (extension === 'obj') {
          var parsedObj = parseOBJ(await file.text());
          if (loadId !== state.loadingId) return;
          acceptAnalysis(parsedObj, 'OBJ');
        } else if (extension === '3mf') {
          var parsed3MF = await parse3MF(await file.arrayBuffer());
          if (loadId !== state.loadingId) return;
          acceptAnalysis(parsed3MF, '3MF');
        } else {
          state.analysis = { canEstimate: false, format: extension.toUpperCase() };
          els.filemeta.textContent = formatBytes(file.size) + ' · ' + extension.toUpperCase();
          if (config.apiUrl) {
            els.priceButton.disabled = false;
            els.priceButton.textContent = 'Slice and price it';
            showStatus('This format will be securely sent to the configured slicer when you calculate the quote.');
          } else {
            els.priceButton.disabled = true;
            els.priceButton.textContent = 'Production slicer required';
            showStatus('STEP and STP need a production slicer. Open “Ask a human” below to request a reviewed quote.', true);
          }
        }
      } catch (error) {
        if (loadId !== state.loadingId) return;
        state.analysis = { canEstimate: false, format: extension.toUpperCase() };
        els.filemeta.textContent = formatBytes(file.size) + ' · Could not read geometry';
        els.priceButton.disabled = !config.apiUrl;
        els.priceButton.textContent = config.apiUrl ? 'Try the production slicer' : 'Request a reviewed quote';
        showStatus('We could not read that model in the browser. ' + (error && error.message ? error.message : 'The file may be damaged or use an unsupported variation.'), true);
      } finally {
        if (loadId === state.loadingId) {
          state.fileLoading = false;
          root.dispatchEvent(new CustomEvent('hive:file-finished'));
        }
      }
    }

    function acceptAnalysis(parsed, format) {
      if (!parsed || !parsed.triangleCount || !isFinite(parsed.volumeCm3)) {
        throw new Error('No printable volume found');
      }
      state.analysis = {
        canEstimate: parsed.volumeCm3 > 0,
        format: format,
        volumeCm3: parsed.volumeCm3,
        dimensions: parsed.dimensions,
        triangleCount: parsed.triangleCount
      };
      state.mesh = parsed.preview;
      state.source = {file:state.file, mesh:parsed.preview, analysis:Object.assign({},state.analysis)};
      state.rotationX = -.52;
      state.rotationY = .68;
      state.zoom = 1;
      els.filemeta.textContent = formatBytes(state.file.size) + ' · ' + formatNumber(parsed.triangleCount) + ' triangles';
      els.help.hidden = false;
      var exceedsBuildVolume = parsed.dimensions.some(function (dimension) { return dimension > config.buildVolume + .001; });
      els.priceButton.disabled = exceedsBuildVolume;
      els.priceButton.textContent = exceedsBuildVolume ? 'Model exceeds print size' : (config.apiUrl ? 'Slice and price it' : 'Calculate my estimate');
      showStatus(
        exceedsBuildVolume
          ? 'Model is ' + formatDimensions(parsed.dimensions) + ' and exceeds the ' + config.buildVolume + ' × ' + config.buildVolume + ' × ' + config.buildVolume + ' mm build volume.'
          : parsed.volumeCm3 > 0 ? 'Model ready · ' + formatDimensions(parsed.dimensions) : 'Model loaded, but its volume needs repair. Enable mold creation to try automatic repair, or use “Ask a human” below.',
        exceedsBuildVolume
      );
      drawModel();
      refreshEligibility();
      state.fileLoading = false;
      root.dispatchEvent(new CustomEvent("hive:file-ready"));
    }

    async function calculateQuote(useApi) {
      if (state.orderBusy || !canPrice()) return;
      if (state.moldEnabled) useApi = false;
      clearStatus();
      els.priceButton.disabled = true;
      els.priceButton.textContent = config.apiUrl && useApi ? 'Slicing your model…' : 'Calculating…';
      try {
        var quote;
        if (config.apiUrl && useApi) {
          try {
            quote = await requestProductionQuote();
          } catch (apiError) {
            if (!state.analysis || !state.analysis.canEstimate) throw apiError;
            quote = estimateLocally();
            showStatus('The production slicer is unavailable, so this is a geometry-based estimate.', true);
          }
        } else {
          if (!state.analysis || !state.analysis.canEstimate) throw new Error('This file needs a production slicer.');
          quote = estimateLocally();
        }
        state.quote = quote;
        renderQuote();
      } catch (error) {
        showStatus(error.message || 'We could not calculate this quote. Please request a reviewed quote.', true);
      } finally {
        els.priceButton.disabled = !canPrice();
        els.priceButton.textContent = state.moldEnabled ? 'Update mold estimate' : config.apiUrl ? 'Re-slice and update price' : 'Update estimate';
      }
    }

    function estimateLocally() {
      var material = selectedMaterial();
      if (!material) throw new Error('Please add at least one material in the Theme Editor.');
      var infill = number(els.infill.value, 15);
      var layerOption = els.layer.options[els.layer.selectedIndex];
      var layerHeight = number(els.layer.value, .2);
      var detailFactor = number(layerOption.dataset.factor, 1);
      var quantity = clamp(Math.round(number(els.quantity.value, 1)), 1, 100);
      els.quantity.value = quantity;
      var fillRatio = .28 + (infill / 100) * .72;
      var supportFactor = els.supports.checked ? 1.12 : 1;
      var weightEach = Math.max(1, state.analysis.volumeCm3 * material.density * fillRatio * supportFactor);
      var hoursEach = Math.max(.35, (weightEach / 13) * detailFactor * (.2 / layerHeight));
      var eachCents = (config.setupFee + weightEach * material.rate + hoursEach * config.machineRate) * material.multiplier;
      var quantityDiscount = quantity >= 10 ? .82 : quantity >= 5 ? .90 : quantity >= 2 ? .96 : 1;
      var totalCents = Math.max(config.minimumPrice, Math.round(eachCents * quantity * quantityDiscount));
      if (els.rush.checked) totalCents = Math.round(totalCents * 1.3);
      totalCents = payableAmount(totalCents);
      // Charge once per successfully repaired model, after print discounts,
      // minimum price, rush production and quote-unit rounding.
      var repairCents = repairFeeCents();
      return {
        id: makeQuoteId(),
        exact: false,
        cents: totalCents + repairCents,
        printingCents: totalCents,
        repairFeeCents: repairCents,
        weightGrams: weightEach * quantity,
        minutes: Math.round(hoursEach * quantity * 60),
        turnaround: els.rush.checked ? '1–2 business days' : quantity >= 10 ? '5–8 business days' : '3–5 business days',
        material: material,
        quantity: quantity,
        layerHeight: layerHeight,
        infill: infill,
        supports: els.supports.checked,
        rush: els.rush.checked,
        token: ''
      };
    }

    async function requestProductionQuote() {
      if (!state.file) throw new Error('Choose a model first.');
      var material = selectedMaterial();
      if (!material) throw new Error('Choose a material first.');
      var payload = currentSpecification(material);
      var body = new FormData();
      body.append('model', state.file, state.file.name);
      body.append('specification', JSON.stringify(payload));
      var response = await fetch(config.apiUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      });
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok || (!data.price_cents && !data.price)) {
        throw new Error(data.message || 'The production slicer could not price this model.');
      }
      var cents = data.price_cents ? number(data.price_cents, 0) : Math.round(number(data.price, 0) * 100);
      return {
        id: String(data.quote_id || makeQuoteId()),
        exact: true,
        cents: payableAmount(cents),
        printingCents: payableAmount(cents),
        repairFeeCents: 0,
        weightGrams: number(data.weight_g, state.analysis && state.analysis.volumeCm3 ? state.analysis.volumeCm3 * material.density : 0),
        minutes: number(data.print_time_minutes, 0),
        turnaround: String(data.turnaround || (els.rush.checked ? '1–2 business days' : '3–5 business days')),
        material: material,
        quantity: number(els.quantity.value, 1),
        layerHeight: number(els.layer.value, .2),
        infill: number(els.infill.value, 15),
        supports: els.supports.checked,
        rush: els.rush.checked,
        token: String(data.upload_token || '')
      };
    }

    function currentSpecification(material) {
      return {
        material: material.name,
        colour: material.colourName,
        layer_height_mm: number(els.layer.value, .2),
        infill_percent: number(els.infill.value, 15),
        supports: els.supports.checked,
        rush: els.rush.checked,
        quantity: number(els.quantity.value, 1),
        local_analysis: state.analysis
      };
    }

    function payableAmount(cents) {
      return config.variantId && config.unitPrice ? Math.ceil(cents / config.unitPrice) * config.unitPrice : cents;
    }

    function repairFeeCents() {
      return state.moldEnabled && state.moldResult && state.moldResult.repair && state.moldResult.repair.applied === true ? config.repairFeeCents : 0;
    }

    function orderPriceProblem() {
      // Never round up a repair fee to suit an incompatible product price.
      return state.quote && config.variantId && config.unitPrice && state.quote.cents % config.unitPrice !== 0
        ? 'Checkout is temporarily unavailable for this estimate. Please contact Hive3D so we can charge the exact total shown.'
        : '';
    }

    function renderQuote() {
      var q = state.quote;
      els.quoteEmpty.hidden = true;
      els.result.hidden = false;
      els.priceLabel.textContent = q.exact ? 'Production quote' : 'Estimated total';
      els.price.textContent = money(q.cents);
      els.breakdown.hidden = !q.repairFeeCents;
      els.printingPrice.textContent = money(q.printingCents);
      els.repairPrice.textContent = money(q.repairFeeCents);
      var materialLabel=root.querySelector('[data-iq-selected-material]');
      if(materialLabel)materialLabel.textContent=q.material.name+(q.material.colourName?' · '+q.material.colourName:'');
      els.badge.textContent = q.exact ? 'Slicer verified' : 'Instant estimate';
      els.weight.textContent = q.weightGrams ? (q.weightGrams < 1000 ? Math.round(q.weightGrams) + ' g' : (q.weightGrams / 1000).toFixed(2) + ' kg') : 'Calculated by slicer';
      els.time.textContent = q.minutes ? formatDuration(q.minutes) : 'Calculated by slicer';
      els.size.textContent = state.analysis && state.analysis.dimensions ? formatDimensions(state.analysis.dimensions) : 'Checked after upload';
      els.turnaround.textContent = q.turnaround;
      els.accuracy.textContent = q.exact ? 'Slicer-verified price. We still run a quick printability check before production.' : config.estimateNotice;
      els.addCart.hidden = false;
      els.addCart.textContent = state.moldEnabled ? 'Add this mold to cart' : 'Add this print to cart';
      els.addCart.disabled = !config.variantId || !config.unitPrice || (state.moldEnabled && !root.querySelector("[data-mold-ack]").checked);
      els.cartNote.classList.remove('is-error');
      els.cartNote.textContent = config.variantId && config.unitPrice
        ? (config.gstIncluded ? 'GST included · Secure Shopify checkout' : 'Taxes and shipping calculated at checkout')
        : 'To enable checkout, select a quote-unit product in the Theme Editor.';
      var uploadProblem = orderPriceProblem() || (window.HiveCustomOrder && window.HiveCustomOrder.fileLimitMessage(root.hiveQuote, root));
      if (uploadProblem) {
        els.addCart.disabled = true;
        els.cartNote.textContent = uploadProblem;
        els.cartNote.classList.add('is-error');
      }
      if (state.moldEnabled && (state.moldMaterialIssue || state.moldMaterialReview)) {
        els.addCart.disabled = true;
        els.cartNote.textContent = state.moldMaterialIssue || state.moldMaterialReview;
      }
      updateContactSummary();
    }

    async function addToCart() {
      if (!window.HiveCustomOrder) { showStatus('The order uploader did not load. Please refresh the page.', true); return; }
      await window.HiveCustomOrder(root, root.hiveQuote);
    }

    function resetQuote() {
      state.quote = null;
      els.quoteEmpty.hidden = false;
      els.result.hidden = true;
      els.addCart.hidden = true;
      els.cartNote.textContent = '';
      if (els.contactSummary) els.contactSummary.value = 'No instant estimate created';
    }

    function updateContactSummary() {
      if (!els.contactSummary || !state.quote) return;
      var q = state.quote;
      els.contactSummary.value = [
        q.id,
        state.file ? state.file.name : 'No filename',
        q.material.name + ' / ' + q.material.colourName,
        'Qty ' + q.quantity,
        q.layerHeight + 'mm, ' + q.infill + '% infill, supports ' + (q.supports ? 'on' : 'off'),
        money(q.cents) + (q.repairFeeCents ? ' including ' + money(q.repairFeeCents) + ' one-off model repair' : ''),
        state.moldEnabled && root.hiveMold ? 'Casting: '+JSON.stringify(root.hiveMold.casting()) : '',
        q.exact ? 'slicer verified' : 'geometry estimate'
      ].join(' · ');
    }

    function selectedMaterial() {
      var input = els.materials.querySelector('input[type="radio"]:checked');
      if (!input) return null;
      return {
        name: input.value,
        colourName: input.dataset.colourName || '',
        colour: input.dataset.colour || '#FFA51F',
        density: number(input.dataset.density, 1.24),
        rate: number(input.dataset.rate, 25),
        multiplier: number(input.dataset.multiplier, 1)
      };
    }

    function isBinarySTL(buffer) {
      if (buffer.byteLength < 84) return false;
      var view = new DataView(buffer);
      var triangles = view.getUint32(80, true);
      return 84 + triangles * 50 <= buffer.byteLength;
    }

    function checkPreviewCount(count) {
      if (count > 1000000) throw new Error('This model has more than 1 million faces. Export a lower-detail solid model to preview it here; we do not remove faces from the preview.');
    }

    function parseBinarySTL(buffer) {
      var view = new DataView(buffer);
      var count = view.getUint32(80, true);
      if (!count || 84 + count * 50 > buffer.byteLength) throw new Error('Invalid binary STL');
      var bounds = freshBounds();
      var volume = 0;
      var preview = [];
      checkPreviewCount(count);
      for (var i = 0; i < count; i++) {
        var offset = 84 + i * 50 + 12;
        var a = [view.getFloat32(offset, true), view.getFloat32(offset + 4, true), view.getFloat32(offset + 8, true)];
        var b = [view.getFloat32(offset + 12, true), view.getFloat32(offset + 16, true), view.getFloat32(offset + 20, true)];
        var c = [view.getFloat32(offset + 24, true), view.getFloat32(offset + 28, true), view.getFloat32(offset + 32, true)];
        include(bounds, a); include(bounds, b); include(bounds, c);
        volume += signedTetrahedron(a, b, c);
        preview.push([a, b, c]);
      }
      return finishGeometry(bounds, volume, count, preview);
    }

    function parseASCIISTL(text) {
      var values = [];
      var re = /vertex\s+([+\-\d.eE]+)\s+([+\-\d.eE]+)\s+([+\-\d.eE]+)/g;
      var match;
      while ((match = re.exec(text)) !== null) values.push([Number(match[1]), Number(match[2]), Number(match[3])]);
      var count = Math.floor(values.length / 3);
      if (!count) throw new Error('Invalid ASCII STL');
      var bounds = freshBounds();
      var volume = 0;
      var preview = [];
      checkPreviewCount(count);
      for (var i = 0; i < count; i++) {
        var a = values[i * 3], b = values[i * 3 + 1], c = values[i * 3 + 2];
        include(bounds, a); include(bounds, b); include(bounds, c);
        volume += signedTetrahedron(a, b, c);
        preview.push([a, b, c]);
      }
      return finishGeometry(bounds, volume, count, preview);
    }

    function parseOBJ(text) {
      var lines = text.split(/\r?\n/);
      var vertices = [];
      var faces = [];
      var bounds = freshBounds();
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (line.indexOf('v ') === 0) {
          var bits = line.split(/\s+/);
          var vertex = [Number(bits[1]), Number(bits[2]), Number(bits[3])];
          if (vertex.every(isFinite)) { vertices.push(vertex); include(bounds, vertex); }
        } else if (line.indexOf('f ') === 0) {
          var refs = line.slice(2).trim().split(/\s+/).map(function (token) {
            var index = parseInt(token.split('/')[0], 10);
            return index < 0 ? vertices.length + index : index - 1;
          });
          for (var f = 1; f < refs.length - 1; f++) faces.push([refs[0], refs[f], refs[f + 1]]);
        }
      }
      if (!vertices.length || !faces.length) throw new Error('OBJ has no faces');
      var volume = 0;
      var preview = [];
      checkPreviewCount(faces.length);
      faces.forEach(function (face, index) {
        var a = vertices[face[0]], b = vertices[face[1]], c = vertices[face[2]];
        if (!a || !b || !c) throw new Error('The OBJ contains invalid face references. Please export it again.');
        volume += signedTetrahedron(a, b, c);
        preview.push([a, b, c]);
      });
      return finishGeometry(bounds, volume, faces.length, preview);
    }

    async function parse3MF(buffer) {
      var entries = find3MFModelEntries(buffer);
      if (!entries.length) throw new Error('The 3MF package does not contain a model.');
      var rootEntry = entries.find(function (item) { return /^3d\/3dmodel\.model$/i.test(item.name); }) || entries[0];
      var documents = {};
      for (var documentIndex = 0; documentIndex < entries.length; documentIndex++) {
        var entry = entries[documentIndex];
        var xmlBytes = await unzipEntry(buffer, entry);
        var xml = new TextDecoder('utf-8').decode(xmlBytes);
        var document3MF = new DOMParser().parseFromString(xml, 'application/xml');
        if (document3MF.getElementsByTagName('parsererror').length) throw new Error('A 3MF model document is damaged.');
        var model = document3MF.documentElement;
        if (!model || model.localName !== 'model') continue;
        var unitScale = {
          micron: .001,
          millimeter: 1,
          centimeter: 10,
          inch: 25.4,
          foot: 304.8,
          meter: 1000
        }[(model.getAttribute('unit') || 'millimeter').toLowerCase()] || 1;
        documents[normalise3MFPath(entry.name)] = { model: model, unitScale: unitScale };
      }

      var rootPath = normalise3MFPath(rootEntry.name);
      if (!documents[rootPath]) throw new Error('The 3MF package has no valid model document.');
      var objects = {};
      Object.keys(documents).forEach(function (documentPath) {
        var modelDocument = documents[documentPath];
        descendants(modelDocument.model, 'object').forEach(function (objectNode) {
          var id = objectNode.getAttribute('id');
          if (!id) return;
          var meshNode = firstChild(objectNode, 'mesh');
          var componentNode = firstChild(objectNode, 'components');
          var objectData = { vertices: [], triangles: [], components: [], documentPath: documentPath };

          if (meshNode) {
            var verticesNode = firstChild(meshNode, 'vertices');
            var trianglesNode = firstChild(meshNode, 'triangles');
            if (verticesNode) {
              childElements(verticesNode, 'vertex').forEach(function (vertex) {
                objectData.vertices.push([
                  number(vertex.getAttribute('x'), 0) * modelDocument.unitScale,
                  number(vertex.getAttribute('y'), 0) * modelDocument.unitScale,
                  number(vertex.getAttribute('z'), 0) * modelDocument.unitScale
                ]);
              });
            }
            if (trianglesNode) {
              childElements(trianglesNode, 'triangle').forEach(function (triangle) {
                objectData.triangles.push([
                  parseInt(triangle.getAttribute('v1'), 10),
                  parseInt(triangle.getAttribute('v2'), 10),
                  parseInt(triangle.getAttribute('v3'), 10)
                ]);
              });
            }
          }

          if (componentNode) {
            childElements(componentNode, 'component').forEach(function (component) {
              var componentPath = getAttributeByLocalName(component, 'path');
              var targetPath = componentPath ? resolve3MFComponentPath(documents, documentPath, componentPath) : documentPath;
              objectData.components.push({
                key: targetPath + '#' + component.getAttribute('objectid'),
                transform: parse3MFTransform(component.getAttribute('transform'))
              });
            });
          }
          objects[documentPath + '#' + id] = objectData;
        });
      });

      var rootModel = documents[rootPath].model;
      var build = firstChild(rootModel, 'build');
      var items = build ? childElements(build, 'item').map(function (item) {
        return { key: rootPath + '#' + item.getAttribute('objectid'), transform: parse3MFTransform(item.getAttribute('transform')) };
      }) : [];
      if (!items.length) {
        Object.keys(objects).forEach(function (key) {
          if (objects[key].documentPath === rootPath && objects[key].triangles.length) {
            items.push({ key: key, transform: identity3MFTransform() });
          }
        });
      }
      if (!items.length) {
        Object.keys(objects).forEach(function (key) {
          if (objects[key].triangles.length) items.push({ key: key, transform: identity3MFTransform() });
        });
      }

      var bounds = freshBounds();
      var preview = [];
      var volume = 0;
      var triangleCount = 0;


      function addTriangle(a, b, c) {
        if (!a || !b || !c || !a.every(isFinite) || !b.every(isFinite) || !c.every(isFinite)) return;
        include(bounds, a); include(bounds, b); include(bounds, c);
        volume += signedTetrahedron(a, b, c);
        triangleCount += 1;
        var rendered = [a, b, c];
        checkPreviewCount(triangleCount);
        preview.push(rendered);
      }

      function emitObject(key, transforms, stack) {
        var objectData = objects[key];
        if (!objectData || stack.indexOf(key) !== -1) return;
        var nextStack = stack.concat(key);
        objectData.triangles.forEach(function (face) {
          var a = objectData.vertices[face[0]], b = objectData.vertices[face[1]], c = objectData.vertices[face[2]];
          if (!a || !b || !c) return;
          addTriangle(apply3MFTransforms(a, transforms), apply3MFTransforms(b, transforms), apply3MFTransforms(c, transforms));
        });
        objectData.components.forEach(function (component) {
          emitObject(component.key, [component.transform].concat(transforms), nextStack);
        });
      }

      items.forEach(function (item) { emitObject(item.key, [item.transform], []); });
      if (!triangleCount) {
        Object.keys(objects).forEach(function (key) {
          if (objects[key].triangles.length) emitObject(key, [identity3MFTransform()], []);
        });
      }
      if (!triangleCount) throw new Error('The 3MF package contains no printable mesh triangles.');
      return finishGeometry(bounds, volume, triangleCount, preview);
    }

    function find3MFModelEntries(buffer) {
      var view = new DataView(buffer);
      var minimum = Math.max(0, buffer.byteLength - 65557);
      var eocd = -1;
      for (var offset = buffer.byteLength - 22; offset >= minimum; offset--) {
        if (view.getUint32(offset, true) === 0x06054b50) { eocd = offset; break; }
      }
      if (eocd < 0) throw new Error('The 3MF ZIP directory is missing.');
      var entryCount = view.getUint16(eocd + 10, true);
      var centralOffset = view.getUint32(eocd + 16, true);
      if (entryCount === 0xffff || centralOffset === 0xffffffff) {
        var locatorOffset = eocd - 20;
        if (locatorOffset < 0 || view.getUint32(locatorOffset, true) !== 0x07064b50) {
          throw new Error('The ZIP64 directory locator is missing.');
        }
        var zip64Offset = readZipUint64(view, locatorOffset + 8);
        if (zip64Offset + 56 > buffer.byteLength || view.getUint32(zip64Offset, true) !== 0x06064b50) {
          throw new Error('The ZIP64 directory is damaged.');
        }
        entryCount = readZipUint64(view, zip64Offset + 32);
        centralOffset = readZipUint64(view, zip64Offset + 48);
      }
      var entries = [];
      var cursor = centralOffset;
      for (var index = 0; index < entryCount; index++) {
        if (cursor + 46 > buffer.byteLength || view.getUint32(cursor, true) !== 0x02014b50) break;
        var compression = view.getUint16(cursor + 10, true);
        var compressedSize = view.getUint32(cursor + 20, true);
        var uncompressedSize = view.getUint32(cursor + 24, true);
        var nameLength = view.getUint16(cursor + 28, true);
        var extraLength = view.getUint16(cursor + 30, true);
        var commentLength = view.getUint16(cursor + 32, true);
        var localOffset = view.getUint32(cursor + 42, true);
        var nameBytes = new Uint8Array(buffer, cursor + 46, nameLength);
        var name = new TextDecoder('utf-8').decode(nameBytes).replace(/\\/g, '/');
        if (compressedSize === 0xffffffff || uncompressedSize === 0xffffffff || localOffset === 0xffffffff) {
          var zip64Values = readZip64Extra(view, cursor + 46 + nameLength, extraLength, {
            compressedSize: compressedSize,
            uncompressedSize: uncompressedSize,
            localOffset: localOffset
          });
          compressedSize = zip64Values.compressedSize;
          uncompressedSize = zip64Values.uncompressedSize;
          localOffset = zip64Values.localOffset;
        }
        entries.push({ name: name, compression: compression, compressedSize: compressedSize, uncompressedSize: uncompressedSize, localOffset: localOffset });
        cursor += 46 + nameLength + extraLength + commentLength;
      }
      return entries.filter(function (item) { return /\.model$/i.test(item.name); });
    }

    function readZipUint64(view, offset) {
      var low = view.getUint32(offset, true);
      var high = view.getUint32(offset + 4, true);
      var value = low + high * 4294967296;
      if (!Number.isSafeInteger(value)) throw new Error('The 3MF ZIP64 package is too large for this browser.');
      return value;
    }

    function readZip64Extra(view, offset, length, values) {
      var cursor = offset;
      var end = offset + length;
      while (cursor + 4 <= end) {
        var headerId = view.getUint16(cursor, true);
        var dataSize = view.getUint16(cursor + 2, true);
        var dataOffset = cursor + 4;
        if (headerId === 0x0001) {
          if (values.uncompressedSize === 0xffffffff && dataOffset + 8 <= end) {
            values.uncompressedSize = readZipUint64(view, dataOffset);
            dataOffset += 8;
          }
          if (values.compressedSize === 0xffffffff && dataOffset + 8 <= end) {
            values.compressedSize = readZipUint64(view, dataOffset);
            dataOffset += 8;
          }
          if (values.localOffset === 0xffffffff && dataOffset + 8 <= end) {
            values.localOffset = readZipUint64(view, dataOffset);
          }
          return values;
        }
        cursor = dataOffset + dataSize;
      }
      throw new Error('A required ZIP64 entry size is missing.');
    }

    async function unzipEntry(buffer, entry) {
      var view = new DataView(buffer);
      if (view.getUint32(entry.localOffset, true) !== 0x04034b50) throw new Error('The 3MF model entry is damaged.');
      var nameLength = view.getUint16(entry.localOffset + 26, true);
      var extraLength = view.getUint16(entry.localOffset + 28, true);
      var dataOffset = entry.localOffset + 30 + nameLength + extraLength;
      var compressed = new Uint8Array(buffer.slice(dataOffset, dataOffset + entry.compressedSize));
      if (entry.compression === 0) return compressed;
      if (entry.compression !== 8) throw new Error('This 3MF uses an unsupported ZIP compression method.');
      if (!window.DecompressionStream) throw new Error('This browser cannot unpack 3MF files. Please update it or upload STL instead.');
      try {
        var stream = new Blob([compressed]).stream().pipeThrough(new DecompressionStream('deflate-raw'));
        return new Uint8Array(await new Response(stream).arrayBuffer());
      } catch (error) {
        throw new Error('The compressed 3MF model could not be unpacked.');
      }
    }

    function getAttributeByLocalName(node, name) {
      for (var index = 0; index < node.attributes.length; index++) {
        if (node.attributes[index].localName === name) return node.attributes[index].value;
      }
      return '';
    }

    function normalise3MFPath(path) {
      var cleanPath = String(path || '');
      try { cleanPath = decodeURIComponent(cleanPath); } catch (error) { /* Keep the original package path. */ }
      var parts = cleanPath.replace(/\\/g, '/').split('/');
      var normalised = [];
      parts.forEach(function (part) {
        if (!part || part === '.') return;
        if (part === '..') normalised.pop();
        else normalised.push(part);
      });
      return normalised.join('/');
    }

    function resolve3MFPath(documentPath, targetPath) {
      if (targetPath.charAt(0) === '/') return normalise3MFPath(targetPath);
      var slash = documentPath.lastIndexOf('/');
      var directory = slash >= 0 ? documentPath.slice(0, slash + 1) : '';
      return normalise3MFPath(directory + targetPath);
    }

    function resolve3MFComponentPath(documents, documentPath, targetPath) {
      var candidates = [
        resolve3MFPath(documentPath, targetPath),
        normalise3MFPath(targetPath)
      ];
      var cleanTarget = normalise3MFPath(targetPath);
      if (!/^3d\//i.test(cleanTarget)) candidates.push(normalise3MFPath('3D/' + cleanTarget));
      for (var index = 0; index < candidates.length; index++) {
        if (documents[candidates[index]]) return candidates[index];
      }
      var filename = cleanTarget.split('/').pop().toLowerCase();
      var matchingPaths = Object.keys(documents).filter(function (path) {
        return path.split('/').pop().toLowerCase() === filename;
      });
      return matchingPaths.length === 1 ? matchingPaths[0] : candidates[0];
    }

    function descendants(node, name) {
      return Array.prototype.filter.call(node.getElementsByTagName('*'), function (element) { return element.localName === name; });
    }

    function childElements(node, name) {
      return Array.prototype.filter.call(node.children || [], function (element) { return element.localName === name; });
    }

    function firstChild(node, name) {
      return childElements(node, name)[0] || null;
    }

    function identity3MFTransform() {
      return [1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0];
    }

    function parse3MFTransform(value) {
      if (!value) return identity3MFTransform();
      var parts = value.trim().split(/\s+/).map(Number);
      return parts.length === 12 && parts.every(isFinite) ? parts : identity3MFTransform();
    }

    function apply3MFTransforms(point, transforms) {
      return transforms.reduce(function (current, transform) {
        var x = current[0], y = current[1], z = current[2];
        return [
          x * transform[0] + y * transform[3] + z * transform[6] + transform[9],
          x * transform[1] + y * transform[4] + z * transform[7] + transform[10],
          x * transform[2] + y * transform[5] + z * transform[8] + transform[11]
        ];
      }, point);
    }

    function freshBounds() {
      return { min: [Infinity, Infinity, Infinity], max: [-Infinity, -Infinity, -Infinity] };
    }

    function include(bounds, point) {
      for (var i = 0; i < 3; i++) {
        bounds.min[i] = Math.min(bounds.min[i], point[i]);
        bounds.max[i] = Math.max(bounds.max[i], point[i]);
      }
    }

    function signedTetrahedron(a, b, c) {
      return (a[0] * (b[1] * c[2] - b[2] * c[1]) - a[1] * (b[0] * c[2] - b[2] * c[0]) + a[2] * (b[0] * c[1] - b[1] * c[0])) / 6;
    }

    function finishGeometry(bounds, signedVolume, triangleCount, preview) {
      var dimensions = [bounds.max[0] - bounds.min[0], bounds.max[1] - bounds.min[1], bounds.max[2] - bounds.min[2]];
      var volumeMm3 = Math.abs(signedVolume);
      if (!isFinite(volumeMm3) || dimensions.some(function(d){return !isFinite(d) || d < 0;})) throw new Error('The model contains invalid dimensions or coordinates.');
      // Keep unreadable volume out of pricing; the complete surface is still
      // available for the mold worker's repair and closed-solid checks.
      if (volumeMm3 < .001) volumeMm3 = 0;
      return { dimensions: dimensions, volumeCm3: volumeMm3 / 1000, triangleCount: triangleCount, preview: preview };
    }

    function resizeCanvas() {
      var rect = els.canvas.getBoundingClientRect();
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var width = Math.max(1, Math.round(rect.width * dpr));
      var height = Math.max(1, Math.round(rect.height * dpr));
      if (els.canvas.width !== width || els.canvas.height !== height) {
        els.canvas.width = width;
        els.canvas.height = height;
      }
    }

    function drawModel() {
      if(window.HiveSolidViewer){
        if(!state.solidViewer)state.solidViewer=new window.HiveSolidViewer(els.canvas);
        var scene=state.scene;
        if(!scene){
          var mesh=state.mesh||[], b=mesh.length?window.HiveSolidViewer.bounds(mesh):{min:[0,0,0],max:[1,1,1],dimensions:[1,1,1]};
          var material=selectedMaterial();
          scene={nodes:mesh.length?[{mesh:mesh,colour:material?material.colour:'#e8a33c'}]:[],bounds:b};
        }
        state.solidViewer.draw({nodes:scene.nodes,bounds:scene.bounds,state:state});
        return;
      }
      var renderer = ensureWebGLRenderer();
      if (renderer) {
        drawModelWebGL(renderer);
        return;
      }
      drawModel2D();
    }

    function ensureWebGLRenderer() {
      if (state.renderer === false) return null;
      if (state.renderer) return state.renderer;

      var gl = els.canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: true }) ||
        els.canvas.getContext('experimental-webgl', { alpha: true, antialias: true, premultipliedAlpha: true });
      if (!gl) {
        state.renderer = false;
        return null;
      }

      var vertexSource = [
        'attribute vec3 a_position;',
        'attribute vec3 a_normal;',
        'uniform vec2 u_scale;',
        'uniform float u_rotation_x;',
        'uniform float u_rotation_y;',
        'varying vec3 v_normal;',
        'vec3 rotateModel(vec3 point) {',
        '  float cy = cos(u_rotation_y);',
        '  float sy = sin(u_rotation_y);',
        '  float cx = cos(u_rotation_x);',
        '  float sx = sin(u_rotation_x);',
        '  vec3 zTurn = vec3(point.x * cy - point.y * sy, point.x * sy + point.y * cy, point.z);',
        '  return vec3(zTurn.x, zTurn.y * cx - zTurn.z * sx, zTurn.y * sx + zTurn.z * cx);',
        '}',
        'void main() {',
        '  vec3 position = rotateModel(a_position);',
        '  v_normal = rotateModel(a_normal);',
        '  gl_Position = vec4(position.x * u_scale.x, position.y * u_scale.y, -position.z, 1.0);',
        '}'
      ].join('\n');
      var fragmentSource = [
        'precision mediump float;',
        'uniform vec3 u_colour;',
        'varying vec3 v_normal;',
        'void main() {',
        '  vec3 normal = normalize(v_normal);',
        '  if (normal.z < 0.0) normal = -normal;',
        '  vec3 keyLight = normalize(vec3(-0.25, 0.45, 1.0));',
        '  vec3 fillLight = normalize(vec3(0.65, -0.2, 0.85));',
        '  float key = max(dot(normal, keyLight), 0.0);',
        '  float fill = max(dot(normal, fillLight), 0.0);',
        '  float rim = pow(1.0 - abs(normal.z), 2.0);',
        '  vec3 reflected = reflect(-keyLight, normal);',
        '  float shine = pow(max(dot(reflected, vec3(0.0, 0.0, 1.0)), 0.0), 28.0);',
        '  float shade = min(1.08, 0.42 + key * 0.48 + fill * 0.20);',
        '  vec3 displayColour = pow(u_colour, vec3(0.82));',
        '  vec3 colour = min(vec3(1.0), displayColour * shade + vec3(shine * 0.28 + rim * 0.055));',
        '  gl_FragColor = vec4(colour, 1.0);',
        '}'
      ].join('\n');

      var program = createWebGLProgram(gl, vertexSource, fragmentSource);
      if (!program) {
        state.renderer = false;
        return null;
      }

      state.renderer = {
        gl: gl,
        program: program,
        positionBuffer: gl.createBuffer(),
        normalBuffer: gl.createBuffer(),
        gridMinorBuffer: gl.createBuffer(),
        gridMajorBuffer: gl.createBuffer(),
        positionLocation: gl.getAttribLocation(program, 'a_position'),
        normalLocation: gl.getAttribLocation(program, 'a_normal'),
        scaleLocation: gl.getUniformLocation(program, 'u_scale'),
        rotationXLocation: gl.getUniformLocation(program, 'u_rotation_x'),
        rotationYLocation: gl.getUniformLocation(program, 'u_rotation_y'),
        colourLocation: gl.getUniformLocation(program, 'u_colour'),
        mesh: null,
        count: 0,
        gridMinorCount: 0,
        gridMajorCount: 0
      };
      return state.renderer;
    }

    function createWebGLProgram(gl, vertexSource, fragmentSource) {
      function compile(type, source) {
        var shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
          gl.deleteShader(shader);
          return null;
        }
        return shader;
      }

      var vertexShader = compile(gl.VERTEX_SHADER, vertexSource);
      var fragmentShader = compile(gl.FRAGMENT_SHADER, fragmentSource);
      if (!vertexShader || !fragmentShader) return null;
      var program = gl.createProgram();
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      gl.deleteShader(vertexShader);
      gl.deleteShader(fragmentShader);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        gl.deleteProgram(program);
        return null;
      }
      return program;
    }

    function drawModelWebGL(renderer) {
      var gl = renderer.gl;
      gl.viewport(0, 0, els.canvas.width, els.canvas.height);
      gl.clearColor(0, 0, 0, 0);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      if (!state.mesh || !state.mesh.length || !state.analysis) return;

      if (renderer.mesh !== state.mesh) uploadWebGLMesh(renderer);
      var material = selectedMaterial();
      var rgb = hexToRgb(material ? material.colour : '#FFA51F');
      var shortestSide = Math.min(els.canvas.width, els.canvas.height);
      var scaleX = 1.38 * shortestSide / els.canvas.width * state.zoom;
      var scaleY = 1.38 * shortestSide / els.canvas.height * state.zoom;

      gl.useProgram(renderer.program);
      gl.enable(gl.DEPTH_TEST);
      gl.depthFunc(gl.LEQUAL);
      gl.disable(gl.CULL_FACE);
      gl.enable(gl.BLEND);
      gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

      gl.uniform2f(renderer.scaleLocation, scaleX, scaleY);
      gl.uniform1f(renderer.rotationXLocation, state.rotationX);
      gl.uniform1f(renderer.rotationYLocation, state.rotationY);

      gl.disableVertexAttribArray(renderer.normalLocation);
      gl.vertexAttrib3f(renderer.normalLocation, 0, 0, 1);
      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.gridMinorBuffer);
      gl.enableVertexAttribArray(renderer.positionLocation);
      gl.vertexAttribPointer(renderer.positionLocation, 3, gl.FLOAT, false, 0, 0);
      gl.uniform3f(renderer.colourLocation, .16, .22, .26);
      gl.drawArrays(gl.LINES, 0, renderer.gridMinorCount);
      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.gridMajorBuffer);
      gl.vertexAttribPointer(renderer.positionLocation, 3, gl.FLOAT, false, 0, 0);
      gl.uniform3f(renderer.colourLocation, .36, .46, .52);
      gl.drawArrays(gl.LINES, 0, renderer.gridMajorCount);

      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.positionBuffer);
      gl.enableVertexAttribArray(renderer.positionLocation);
      gl.vertexAttribPointer(renderer.positionLocation, 3, gl.FLOAT, false, 0, 0);
      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.normalBuffer);
      gl.enableVertexAttribArray(renderer.normalLocation);
      gl.vertexAttribPointer(renderer.normalLocation, 3, gl.FLOAT, false, 0, 0);

      gl.uniform3f(renderer.colourLocation, rgb.r / 255, rgb.g / 255, rgb.b / 255);
      gl.drawArrays(gl.TRIANGLES, 0, renderer.count);
    }

    function uploadWebGLMesh(renderer) {
      var gl = renderer.gl;
      var minimum = [getMinimum(state.mesh, 0), getMinimum(state.mesh, 1), getMinimum(state.mesh, 2)];
      var dims = state.previewDimensions || state.analysis.dimensions;
      var maxDim = Math.max(dims[0], dims[1], dims[2], 1);
      var faces = [];
      var connected = Object.create(null);

      state.mesh.forEach(function (triangle) {
        var points = triangle.map(function (point) {
          return [
            (point[0] - minimum[0] - dims[0] / 2) / maxDim,
            (point[1] - minimum[1] - dims[1] / 2) / maxDim,
            (point[2] - minimum[2] - dims[2] / 2) / maxDim
          ];
        });
        var edgeA = subtract3(points[1], points[0]);
        var edgeB = subtract3(points[2], points[0]);
        var weightedNormal = cross3(edgeA, edgeB);
        var faceNormal = normalise3(weightedNormal);
        if (!faceNormal) return;
        var face = { points: points, normal: faceNormal, weightedNormal: weightedNormal };
        faces.push(face);
        points.forEach(function (point) {
          var key = vertexKey(point);
          if (!connected[key]) connected[key] = [];
          connected[key].push(face);
        });
      });

      var positions = new Float32Array(faces.length * 9);
      var normals = new Float32Array(faces.length * 9);
      var cursor = 0;
      faces.forEach(function (face) {
        face.points.forEach(function (point) {
          var neighbours = connected[vertexKey(point)] || [face];
          var sum = [0, 0, 0];
          neighbours.forEach(function (neighbour) {
            if (dot3(face.normal, neighbour.normal) >= .55) {
              sum[0] += neighbour.weightedNormal[0];
              sum[1] += neighbour.weightedNormal[1];
              sum[2] += neighbour.weightedNormal[2];
            }
          });
          var smoothNormal = normalise3(sum) || face.normal;
          positions[cursor] = point[0]; normals[cursor++] = smoothNormal[0];
          positions[cursor] = point[1]; normals[cursor++] = smoothNormal[1];
          positions[cursor] = point[2]; normals[cursor++] = smoothNormal[2];
        });
      });

      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.positionBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, positions, gl.STATIC_DRAW);
      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.normalBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, normals, gl.STATIC_DRAW);
      uploadBuildPlate(renderer, maxDim, dims);
      renderer.mesh = state.mesh;
      renderer.count = faces.length * 3;
    }

    function uploadBuildPlate(renderer, maxDim, dims) {
      var halfPlate = config.buildVolume / 2;
      var baseZ = -dims[2] / (2 * maxDim) - .003;
      var minor = [];
      var major = [];

      function addLine(target, x1, y1, x2, y2) {
        target.push(x1 / maxDim, y1 / maxDim, baseZ, x2 / maxDim, y2 / maxDim, baseZ);
      }

      var lastGridLine = Math.floor(halfPlate / 10) * 10;
      for (var millimetres = -lastGridLine; millimetres <= lastGridLine; millimetres += 10) {
        var target = millimetres === 0 || Math.abs(millimetres) % 50 === 0 ? major : minor;
        addLine(target, millimetres, -halfPlate, millimetres, halfPlate);
        addLine(target, -halfPlate, millimetres, halfPlate, millimetres);
      }

      addLine(major, -halfPlate, -halfPlate, halfPlate, -halfPlate);
      addLine(major, halfPlate, -halfPlate, halfPlate, halfPlate);
      addLine(major, halfPlate, halfPlate, -halfPlate, halfPlate);
      addLine(major, -halfPlate, halfPlate, -halfPlate, -halfPlate);

      var gl = renderer.gl;
      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.gridMinorBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(minor), gl.STATIC_DRAW);
      gl.bindBuffer(gl.ARRAY_BUFFER, renderer.gridMajorBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(major), gl.STATIC_DRAW);
      renderer.gridMinorCount = minor.length / 3;
      renderer.gridMajorCount = major.length / 3;
    }

    function vertexKey(point) {
      return Math.round(point[0] * 100000) + ',' + Math.round(point[1] * 100000) + ',' + Math.round(point[2] * 100000);
    }

    function subtract3(a, b) {
      return [a[0] - b[0], a[1] - b[1], a[2] - b[2]];
    }

    function cross3(a, b) {
      return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
    }

    function dot3(a, b) {
      return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    }

    function normalise3(vector) {
      var length = Math.sqrt(dot3(vector, vector));
      return length > .00000001 ? [vector[0] / length, vector[1] / length, vector[2] / length] : null;
    }

    function drawModel2D() {
      var ctx = els.canvas.getContext('2d');
      var width = els.canvas.width;
      var height = els.canvas.height;
      ctx.clearRect(0, 0, width, height);
      if (!state.mesh || !state.mesh.length || !state.analysis) return;

      var dims = state.previewDimensions || state.analysis.dimensions;
      var maxDim = Math.max(dims[0], dims[1], dims[2], 1);
      var center = [dims[0] / 2, dims[1] / 2, dims[2] / 2];
      var scale = Math.min(width, height) * .66 / maxDim * state.zoom;
      var material = selectedMaterial();
      var rgb = hexToRgb(material ? material.colour : '#FFA51F');
      var cosY = Math.cos(state.rotationY), sinY = Math.sin(state.rotationY);
      var cosX = Math.cos(state.rotationX), sinX = Math.sin(state.rotationX);

      var projected = state.mesh.map(function (triangle) {
        var points = triangle.map(function (point) {
          var x = point[0] - (dims[0] + getMinimum(state.mesh, 0) * 2) / 2;
          var y = point[1] - (dims[1] + getMinimum(state.mesh, 1) * 2) / 2;
          var z = point[2] - (dims[2] + getMinimum(state.mesh, 2) * 2) / 2;
          var x1 = x * cosY - y * sinY;
          var y1 = x * sinY + y * cosY;
          var y2 = y1 * cosX - z * sinX;
          var z2 = y1 * sinX + z * cosX;
          return [width / 2 + x1 * scale, height / 2 - y2 * scale, z2];
        });
        var a = triangle[1].map(function(v,i){return v-triangle[0][i];});
        var b = triangle[2].map(function(v,i){return v-triangle[0][i];});
        var normal = [a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]];
        var length = Math.hypot.apply(null,normal)||1;
        normal=normal.map(function(v){return v/length;});
        var nx=normal[0]*cosY-normal[1]*sinY, ny=normal[0]*sinY+normal[1]*cosY;
        var ry=ny*cosX-normal[2]*sinX, rz=ny*sinX+normal[2]*cosX;
        var lighting=.28+.67*Math.max(0,-.3*nx-.35*ry+.88*rz);
        return { points: points, depth: (points[0][2] + points[1][2] + points[2][2]) / 3, light:lighting };
      });
      projected.sort(function (a, b) { return a.depth - b.depth; });

      projected.forEach(function (triangle) {
        var p = triangle.points;
        var light = clamp(triangle.light, .22, .98);
        ctx.beginPath();
        ctx.moveTo(p[0][0], p[0][1]);
        ctx.lineTo(p[1][0], p[1][1]);
        ctx.lineTo(p[2][0], p[2][1]);
        ctx.closePath();
        ctx.fillStyle = 'rgb(' + Math.round(rgb.r * light) + ',' + Math.round(rgb.g * light) + ',' + Math.round(rgb.b * light) + ')';
        ctx.fill();
        ctx.strokeStyle=ctx.fillStyle;ctx.lineWidth=.45;ctx.stroke();
      });
    }

    var minimumCache = null;
    function getMinimum(mesh, axis) {
      if (!minimumCache || minimumCache.mesh !== mesh) {
        var min = [Infinity, Infinity, Infinity];
        mesh.forEach(function (triangle) { triangle.forEach(function (point) { for (var i = 0; i < 3; i++) min[i] = Math.min(min[i], point[i]); }); });
        minimumCache = { mesh: mesh, min: min };
      }
      return minimumCache.min[axis];
    }

    function normalLight(points) {
      var ax = points[1][0] - points[0][0], ay = points[1][1] - points[0][1];
      var bx = points[2][0] - points[0][0], by = points[2][1] - points[0][1];
      var cross = ax * by - ay * bx;
      return cross >= 0 ? .85 : .4;
    }

    function hexToRgb(hex) {
      var clean = String(hex || '').replace('#', '');
      if (clean.length === 3) clean = clean.split('').map(function (c) { return c + c; }).join('');
      var value = parseInt(clean, 16);
      return isFinite(value) ? { r: value >> 16 & 255, g: value >> 8 & 255, b: value & 255 } : { r: 255, g: 165, b: 31 };
    }

    function money(cents) {
      try { return new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(cents / 100); }
      catch (error) { return '$' + (cents / 100).toFixed(2); }
    }

    function formatDimensions(dimensions) {
      return dimensions.map(function (value) { return Math.max(0, value).toFixed(value < 10 ? 1 : 0); }).join(' × ') + ' mm';
    }

    function formatDuration(minutes) {
      var rounded = Math.max(1, Math.round(minutes));
      if (rounded < 60) return rounded + ' min';
      var hours = Math.floor(rounded / 60);
      var mins = rounded % 60;
      return hours + 'h' + (mins ? ' ' + mins + 'm' : '');
    }

    function formatBytes(bytes) {
      if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
      return (bytes / 1024 / 1024).toFixed(1) + ' MB';
    }

    function formatNumber(value) {
      try { return new Intl.NumberFormat(config.locale).format(value); }
      catch (error) { return String(value); }
    }

    function makeQuoteId() {
      var part = Math.random().toString(36).slice(2, 8).toUpperCase();
      return 'HIVE-' + part;
    }

    function showStatus(message, error) {
      els.status.textContent = message;
      els.status.classList.toggle('is-error', !!error);
    }

    function clearStatus() {
      els.status.textContent = '';
      els.status.classList.remove('is-error');
    }

    function number(value, fallback) {
      var parsed = Number(value);
      return isFinite(parsed) ? parsed : fallback;
    }

    function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
  }
})();
